import { DiscussionEntityRef, DiscussionMessage } from '../domain/types';
import { DiscussionRepository } from '../application/ports';

const storageKey = (ref: DiscussionEntityRef) =>
  `discussion:${ref.entityType}:${String(ref.entityId)}`;

const nowIso = () => new Date().toISOString();

const parseMessages = (raw: string | null): DiscussionMessage[] => {
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const createLocalStorageDiscussionRepository = (): DiscussionRepository => ({
  getMessages: async (ref, _cursor, take = 50) => {
    if (typeof window === 'undefined') {
      return { items: [] };
    }

    const raw = window.localStorage.getItem(storageKey(ref));
    const all = parseMessages(raw);
    const items = all.slice(Math.max(0, all.length - take));
    return { items };
  },
  sendMessage: async (ref, input) => {
    const createdAt = nowIso();
    const message: DiscussionMessage = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      entityType: ref.entityType,
      entityId: String(ref.entityId),
      senderId: 'local-user',
      senderDisplayName: 'Current user',
      text: input.text,
      createdAt,
      updatedAt: createdAt,
      clientMessageId: input.clientMessageId,
    };

    if (typeof window === 'undefined') {
      return message;
    }

    const key = storageKey(ref);
    const current = parseMessages(window.localStorage.getItem(key));
    current.push(message);
    window.localStorage.setItem(key, JSON.stringify(current));
    return message;
  },
});
